export const gameReport = {
  gameReport: "Game Report",
  from: "From",
  to: "To",
  exportReport: "Export Report",
  totalPlayers: "Total Players",
  totalBetRounds: "Total Bet Rounds",
  totalBetAmount: "Total Bet Amount",
  totalWinloss: "Total Win/Loss",
  providerName: "PROVIDER NAME",
  player: "PLAYER",
  betAmount: "BET AMOUNT",
  validBetAmount: "VALID BET AMOUNT",
  winloss: "WIN/LOSS",
  winlossPercent: "WIN/LOSS %",
  total: "Total",
};
